import { bootGtmIfConfigured } from './boot-gtm';
import { isAnalyticsAllowed } from './analytics-allowed';

export const VIRTUAL_PAGE_VIEW_EVENT = 'virtual_page_view';

export type VirtualPageView = {
    event: typeof VIRTUAL_PAGE_VIEW_EVENT;
    /** Pathname only — a query string can carry search text, so it is never sent. */
    page_path: string;
    page_location: string;
    /** The route's static English title, never a record's data (see `route-title.ts`). */
    page_title: string;
};

declare global {
    interface Window {
        dataLayer?: unknown[];
    }
}

/**
 * ROBO-932 — one SPA page view for GTM. The container fires its GA4 `page_view` on this event for
 * `/ux/` pages; legacy pages share the container and keep their automatic page view (the ticket
 * carries the container change).
 *
 * Pushed only after GTM has booted, so the event never sits in `dataLayer` ahead of `gtm.js` — and
 * never at all without consent, under GPC, or with no container id.
 */
export function pushPageView(pathname: string, pageTitle: string): Promise<boolean> {
    if (!isAnalyticsAllowed() || !import.meta.env.VITE_GTM_ID) {
        return Promise.resolve(false);
    }
    return bootGtmIfConfigured().then(() => {
        const view: VirtualPageView = {
            event: VIRTUAL_PAGE_VIEW_EVENT,
            page_path: pathname,
            page_location: `${window.location.origin}${pathname}`,
            page_title: pageTitle
        };
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(view);
        return true;
    });
}
